import React from 'react';

export const BLINK_DEVICE_LED_MIN_API_VERSION = 4;

// TODO: use cm getProductTypes API to map specific types
export const PRODUCT_TYPES = {
  donor: ['donor', 'HBF_DONOR'],
  service: ['HBF_SERVICE', 'HORN_WIDE_SERVICE', 'HORN_NARROW_SERVICE', 'service'],
  ga2: ['ga2-n257', 'ga2-n258', 'ga2-n260'],
  echo: ['ES3_28', 'subscriber', 'ES4_39', 'ESX_M5', 'ESX_M6']
};

export const DEFAULT_TAB_FILTER = {
  pivot: {
    'properties.reported.productType': [...PRODUCT_TYPES.donor, ...PRODUCT_TYPES.service, ...PRODUCT_TYPES.ga2]
  },
  echo: {
    'properties.reported.productType': [...PRODUCT_TYPES.echo]
  },
  all: {}
};

export const browserWarningMessage = {
  title: 'Mobile Browser\nNot Supported',
  body1:
    'It looks like you are attempting to open IBMS from a mobile browser. IBMS does not support running on mobile browsers, please access IBMS from a desktop or tablet.',
  body2: 'We recommend using the latest desktop or tablet version of Chrome, Firefox, or Edge.'
};

export const Status = {
  NONE: 0,
  PENDING: 1,
  SUCCESS: 2,
  FAILURE: 3
};

export const Alarms = {
  INDETERMINATE: -2,
  UNDEFINED_SEVERITY: -1,
  CLEARED: 0,
  INFO: 1,
  WARNING: 2,
  MINOR: 3,
  MAJOR: 4,
  CRITICAL: 5
};

export const timeZoneAbbrToFull = {
  EST: 'Eastern Standard Time',
  EDT: 'Eastern Daylight Time',
  CST: 'Central Standard Time',
  CDT: 'Central Daylight Time',
  MST: 'Mountain Standard Time',
  MDT: 'Mountain Daylight Time',
  PST: 'Pacific Standard Time',
  PDT: 'Pacific Daylight Time'
};

export const hour_list = {
  '12:00 am': { hour: 0, minute: 0 },
  '12:30 am': { hour: 0, minute: 30 },
  '01:00 am': { hour: 1, minute: 0 },
  '01:30 am': { hour: 1, minute: 30 },
  '02:00 am': { hour: 2, minute: 0 },
  '02:30 am': { hour: 2, minute: 30 },
  '03:00 am': { hour: 3, minute: 0 },
  '03:30 am': { hour: 3, minute: 30 },
  '04:00 am': { hour: 4, minute: 0 },
  '04:30 am': { hour: 4, minute: 30 },
  '05:00 am': { hour: 5, minute: 0 },
  '05:30 am': { hour: 5, minute: 30 },
  '06:00 am': { hour: 6, minute: 0 },
  '06:30 am': { hour: 6, minute: 30 },
  '07:00 am': { hour: 7, minute: 0 },
  '07:30 am': { hour: 7, minute: 30 },
  '08:00 am': { hour: 8, minute: 0 },
  '08:30 am': { hour: 8, minute: 30 },
  '09:00 am': { hour: 9, minute: 0 },
  '09:30 am': { hour: 9, minute: 30 },
  '10:00 am': { hour: 10, minute: 0 },
  '10:30 am': { hour: 10, minute: 30 },
  '11:00 am': { hour: 11, minute: 0 },
  '11:30 am': { hour: 11, minute: 30 },
  '12:00 pm': { hour: 12, minute: 0 },
  '12:30 pm': { hour: 12, minute: 30 },
  '01:00 pm': { hour: 13, minute: 0 },
  '01:30 pm': { hour: 13, minute: 30 },
  '02:00 pm': { hour: 14, minute: 0 },
  '02:30 pm': { hour: 14, minute: 30 },
  '03:00 pm': { hour: 15, minute: 0 },
  '03:30 pm': { hour: 15, minute: 30 },
  '04:00 pm': { hour: 16, minute: 0 },
  '04:30 pm': { hour: 16, minute: 30 },
  '05:00 pm': { hour: 17, minute: 0 },
  '05:30 pm': { hour: 17, minute: 30 },
  '06:00 pm': { hour: 18, minute: 0 },
  '06:30 pm': { hour: 18, minute: 30 },
  '07:00 pm': { hour: 19, minute: 0 },
  '07:30 pm': { hour: 19, minute: 30 },
  '08:00 pm': { hour: 20, minute: 0 },
  '08:30 pm': { hour: 20, minute: 30 },
  '09:00 pm': { hour: 21, minute: 0 },
  '09:30 pm': { hour: 21, minute: 30 },
  '10:00 pm': { hour: 22, minute: 0 },
  '10:30 pm': { hour: 22, minute: 30 },
  '11:00 pm': { hour: 23, minute: 0 },
  '11:30 pm': { hour: 23, minute: 30 }
};

export const hour_list_24 = {
  '00:00': { hour: 0, minute: 0 },
  '00:30': { hour: 0, minute: 30 },
  '01:00': { hour: 1, minute: 0 },
  '01:30': { hour: 1, minute: 30 },
  '02:00': { hour: 2, minute: 0 },
  '02:30': { hour: 2, minute: 30 },
  '03:00': { hour: 3, minute: 0 },
  '03:30': { hour: 3, minute: 30 },
  '04:00': { hour: 4, minute: 0 },
  '04:30': { hour: 4, minute: 30 },
  '05:00': { hour: 5, minute: 0 },
  '05:30': { hour: 5, minute: 30 },
  '06:00': { hour: 6, minute: 0 },
  '06:30': { hour: 6, minute: 30 },
  '07:00': { hour: 7, minute: 0 },
  '07:30': { hour: 7, minute: 30 },
  '08:00': { hour: 8, minute: 0 },
  '08:30': { hour: 8, minute: 30 },
  '09:00': { hour: 9, minute: 0 },
  '09:30': { hour: 9, minute: 30 },
  '10:00': { hour: 10, minute: 0 },
  '10:30': { hour: 10, minute: 30 },
  '11:00': { hour: 11, minute: 0 },
  '11:30': { hour: 11, minute: 30 },
  '12:00': { hour: 12, minute: 0 },
  '12:30': { hour: 12, minute: 30 },
  '13:00': { hour: 13, minute: 0 },
  '13:30': { hour: 13, minute: 30 },
  '14:00': { hour: 14, minute: 0 },
  '14:30': { hour: 14, minute: 30 },
  '15:00': { hour: 15, minute: 0 },
  '15:30': { hour: 15, minute: 30 },
  '16:00': { hour: 16, minute: 0 },
  '16:30': { hour: 16, minute: 30 },
  '17:00': { hour: 17, minute: 0 },
  '17:30': { hour: 17, minute: 30 },
  '18:00': { hour: 18, minute: 0 },
  '18:30': { hour: 18, minute: 30 },
  '19:00': { hour: 19, minute: 0 },
  '19:30': { hour: 19, minute: 30 },
  '20:00': { hour: 20, minute: 0 },
  '20:30': { hour: 20, minute: 30 },
  '21:00': { hour: 21, minute: 0 },
  '21:30': { hour: 21, minute: 30 },
  '22:00': { hour: 22, minute: 0 },
  '22:30': { hour: 22, minute: 30 },
  '23:00': { hour: 23, minute: 0 },
  '23:30': { hour: 23, minute: 30 }
};

//Formatted as
//F_DL_Low, N_Offs_DL, N_DL_Low_Range, N_DL_High_Range
export const F_DL_FormulaValues = [
  [2110, 0, 0, 599],
  [1930, 600, 600, 1199],
  [1805, 1200, 1200, 1949],
  [2110, 1950, 1950, 2399],
  [869, 2400, 2400, 2649],
  [875, 2650, 2650, 2749],
  [2620, 2750, 2750, 3449],
  [925, 3450, 3450, 3799],
  [1844.9, 3800, 3800, 4149],
  [2110, 4150, 4150, 4749],
  [1475.9, 4750, 4750, 4949],
  [729, 5010, 5010, 5179],
  [746, 5180, 5180, 5279],
  [758, 5280, 5280, 5379],
  [734, 5730, 5730, 5849],
  [860, 5850, 5850, 5999],
  [875, 6000, 6000, 6149],
  [791, 6150, 6150, 6449],
  [1495.9, 6450, 6450, 6599],
  [3510, 6600, 6600, 7399],
  [2180, 7500, 7500, 7699],
  [1525, 7700, 7700, 8039],
  [1930, 8040, 8040, 8689],
  [1900, 36000, 36000, 36199],
  [2010, 36200, 36200, 36349],
  [1850, 36350, 36350, 36949],
  [1930, 36950, 36950, 37549],
  [1910, 37550, 37550, 37749],
  [2570, 37750, 37750, 38249],
  [1880, 38250, 38250, 38649],
  [2300, 38650, 38650, 39649],
  [2496, 39650, 39650, 41589],
  [3400, 41590, 41590, 43589],
  [3600, 43590, 43590, 45589]
];

export const paramLabelValues = {
  deviceTwin_reported_antenna_direction_beamAzimuth: 'Azimuth',
  deviceTwin_reported_antenna_direction_beamElevation: 'Elevation',
  deviceTwin_reported_VDL_Gain_value: 'Downlink gain V',
  deviceTwin_reported_HDL_Gain_value: 'Downlink gain H',
  deviceTwin_reported_VUL_Gain_value: 'Uplink gain V',
  deviceTwin_reported_HUL_Gain_value: 'Uplink gain H'
};

export const paramLabelValueList = [
  'deviceTwin_reported_antenna_direction_beamAzimuth',
  'deviceTwin_reported_antenna_direction_beamElevation',
  'deviceTwin_reported_VDL_Gain_value',
  'deviceTwin_reported_HDL_Gain_value',
  'deviceTwin_reported_VUL_Gain_value',
  'deviceTwin_reported_HUL_Gain_value'
];

export const deviceDisplayTypes = {
  ID: 0,
  NAME: 1
};

export const defaultChartSelectionConfig = {
  panelData: [
    {
      panelTitle: 'Time chart view',
      metricList: [
        {
          type: 'resolution',
          title: 'Resolution',
          format: 'dataButtonList',
          data: [
            {
              label: '5 min',
              value: '5m',
              active: false
            },
            {
              label: '15 min',
              value: '15m',
              active: true
            },
            {
              label: 'Hourly',
              value: '1h',
              active: false
            },
            {
              label: 'Daily',
              value: '1d',
              active: false
            }
          ]
        },
        {
          type: 'time',
          title: 'Time',
          format: 'dropdown',
          data: [
            {
              label: 'Past Hour',
              value: 60,
              active: false
            },
            {
              label: 'Past 24 hours',
              value: 60 * 24,
              active: false
            },
            {
              label: 'Past Week',
              value: 60 * 24 * 7,
              active: true
            },
            {
              label: 'Past Month',
              value: 60 * 24 * 30,
              active: false
            }
          ]
        }
      ],
      kpiList: [
        {
          kpiConfigSections: [
            {
              type: 'kpiType',
              title: 'KPI 1',
              format: 'dropdown',
              data: [
                // {
                //   label: "Temperature",
                //   value: "systemTemp",
                //   active: true
                // },
                // {
                //   label: "System Uptime",
                //   value: "sysUpTime",
                //   active: false
                // },
                // {
                //   label: "PanelPower.HPolDL",
                //   value: "PanelPower_HPolDL",
                //   active: false
                // },
                // {
                //   label: "PanelPower.HPolUL",
                //   value: "PanelPower_HPolUL",
                //   active: false
                // },
                // {
                //   label: "PanelPower.VPolDL",
                //   value: "PanelPower_VPolDL",
                //   active: false
                // },
                // {
                //   label: "PanelPower.VPolUL",
                //   value: "PanelPower_VPolUL",
                //   active: false
                // }
              ]
            },
            {
              type: 'chartFormat',
              title: null,
              format: 'iconButtonList',
              data: [
                {
                  value: 'bar',
                  active: false
                },
                {
                  value: 'line',
                  active: true
                },
                {
                  value: 'area',
                  active: false
                }
              ]
            },
            {
              type: 'yLean',
              title: null,
              format: 'dataButtonList',
              data: [
                {
                  label: 'Left Y',
                  value: 'left',
                  active: true
                },
                {
                  label: 'Right Y',
                  value: 'right',
                  active: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      panelTitle: 'XY chart view',
      // chartFormat: "Bar",
      metricList: [
        {
          type: 'sample Resolution',
          title: 'Sample Resolution',
          format: 'dataButtonList',
          data: [
            {
              label: '1 min',
              value: 5,
              active: false
            },
            {
              label: '2 min',
              value: 15,
              active: false
            },
            {
              label: 'Bi-Hourly',
              value: 60,
              active: false
            },
            {
              label: 'Bi-Daily',
              value: 60 * 24,
              active: false
            }
          ]
        },
        {
          type: 'sample Metric',
          title: 'Sample Metric',
          format: 'dataButtonList',
          data: [
            {
              label: 'Mode 1',
              value: 60,
              active: false
            },
            {
              label: 'Mode 2',
              value: 60 * 24,
              active: false
            },
            {
              label: 'Mode 3',
              value: 60 * 24 * 7,
              active: false
            }
          ]
        }
      ]
    }
  ]
};

export const LOADING_CIRCLE = (
  <svg className="spinner" viewBox="0 0 50 50">
    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
  </svg>
);

export const BUTTON_LOADING_CIRCLE = (
  <svg className="buttonSpinner" viewBox="0 0 50 50">
    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
  </svg>
);

export const _random_colors = [];
while (_random_colors.length < 100) {
  let r = ('00' + Number(Math.floor(Math.random() * 256)).toString(16)).slice(-2);
  let g = ('00' + Number(Math.floor(Math.random() * 256)).toString(16)).slice(-2);
  let b = ('00' + Number(Math.floor(Math.random() * 256)).toString(16)).slice(-2);
  _random_colors.push('#' + r + g + b);
}

export const DefaultPieChartColors = [
  '#ff853a',
  '#06749f',
  '#909090',
  '#5ebdfd',
  '#ffaf3a',
  '#556e8f',
  '#d1d1d1',
  '#e8e181',
  '#77e4cf',
  '#616161',
  '#00dce9',
  '#007899',
  '#c57100',
  '#00e96a'
].concat(_random_colors);

export const SPECIAL_CHARS_FORMAT = /[!@#$%^&*()+=[\]{};':"\\|,.<>/?]+/;

export const defaultDeviceTypesSelection = [
  {
    title: 'ES3_28',
    name: 'es3_28',
    selected: false
  },
  {
    title: 'ES4_39',
    name: 'es4_39',
    selected: false
  },
  {
    title: 'Pivot 5G',
    name: 'pivot5g',
    selected: false
  },
  {
    title: 'ESX_M6',
    name: 'esx_m6',
    selected: false
  },
  {
    title: 'ESX_M5',
    name: 'esx_m5',
    selected: false
  },
  {
    title: 'GA2-N257',
    name: 'ga2-n257',
    selected: false
  },
  {
    title: 'GA2-N258',
    name: 'ga2-n258',
    selected: false
  },
  {
    title: 'GA2-N260',
    name: 'ga2-n260',
    selected: false
  }
];

export const defaultSWDeviceTypes = {
  es3_28: {
    title: 'ES3_28',
    name: 'es3_28'
  },
  es4_39: {
    title: 'ES4_39',
    name: 'es4_39'
  },
  pivot5g: {
    title: 'Pivot 5G',
    name: 'pivot5g'
  },
  esx_m6: {
    title: 'ESX_M6',
    name: 'esx_m6'
  },
  esx_m5: {
    title: 'ESX_M5',
    name: 'esx_m5'
  },
  'ga2-n257': {
    title: 'GA2-N257',
    name: 'ga2-n257'
  },
  'ga2-n258': {
    title: 'GA2-N258',
    name: 'ga2-n258'
  },
  'ga2-n260': {
    title: 'GA2-N260',
    name: 'ga2-n260'
  }
};

export const defaultDeviceTableSearchBody = {
  size: 50,
  coalesceBundles: true,
  filters: {},
  returnFields: [
    'deviceId',
    'connectionState',
    'lastActivityTime',
    'properties.reported.softwareLoad',
    'properties.reported.location',
    'properties.reported.productType',
    'properties.reported.lastResetReason',
    'properties.reported.adminState',
    'properties.reported.wifi',
    'properties.reported.antenna_direction',
    'properties.reported.systemOrientation',
    'properties.reported.VDL_Gain',
    'properties.reported.HDL_Gain',
    'properties.reported.VUL_Gain',
    'properties.reported.HUL_Gain',
    // GA2 sw version path
    'properties.reported.DU.swdl-releases.active-release.sys-sw-rel',
    'tags',
    'tags.userLabel',
    'tags.fm-alarms',
    'tags.bundle'
  ],
  aggregations: {
    connectionState: {
      group_by: {
        field: 'connectionState',
        agg: 'count'
      }
    },
    softwareLoad: {
      group_by: {
        field: 'properties.reported.softwareLoad',
        agg: 'count'
      }
    },
    adminState: {
      group_by: {
        field: 'properties.reported.adminState',
        agg: 'count'
      }
    },
    lastResetReason: {
      group_by: {
        field: 'properties.reported.lastResetReason',
        agg: 'count'
      }
    }
  }
};

export const defaultDeviceMapSearchBody = {
  coalesceBundles: true,
  filters: {},
  returnFields: [
    'deviceId',
    'connectionState',
    'properties.reported.adminState',
    'properties.reported.DU.center-freq',
    'properties.reported.DU.center-arfcn',
    'properties.reported.softwareLoad',
    'properties.reported.location',
    'properties.reported.productType',
    'properties.reported.lastResetReason',
    'tags',
    'tags.userLabel',
    'tags.fm-alarms',
    'tags.bundle'
  ]
};

export const defaultParametersTableSearchBody = {
  size: 50,
  coalesceBundles: false,
  returnFields: [
    'deviceId',
    'tags',
    'connectionState',
    'properties.reported.softwareLoad',
    'properties.reported.adminState',
    'properties.reported.lastResetReason',
    'properties.reported.productType'
  ]
};

export const defaultParametersGraphSearchBody = {
  size: 10000,
  coalesceBundles: false,
  returnFields: ['deviceId'],
  aggregations: {
    connectionState: {
      group_by: {
        field: 'connectionState',
        agg: 'count'
      }
    },
    softwareLoad: {
      group_by: {
        field: 'properties.reported.softwareLoad',
        agg: 'count'
      }
    },
    adminState: {
      group_by: {
        field: 'properties.reported.adminState',
        agg: 'count'
      }
    },
    lastResetReason: {
      group_by: {
        field: 'properties.reported.lastResetReason',
        agg: 'count'
      }
    }
  }
};

export const defaultParameterGraphAggregateBody = {
  fieldNames: ['connectionState', 'adminState', 'lastResetReason']
};

export const defaultSearchBody = {
  size: 10000,
  filters: {},
  coalesceBundles: true
};

export const defaultSearchBodies = {
  deviceTable: defaultDeviceTableSearchBody,
  deviceMap: defaultDeviceMapSearchBody,
  parametersTable: defaultParametersTableSearchBody,
  parametersGraph: defaultParametersGraphSearchBody
};
export const LogLevels = {
  DEBUG: 0,
  INFO: 1,
  MAX: 2
};

export const DEBUG_LEVEL = LogLevels.MAX; // higher levels -> fewer prints. MAX -> no prints

export const API_DEBUG_MODE = true;
export const API_DEBUG_SU = API_DEBUG_MODE; // also use fake device for su pivot provisioning steps

export const AzelRange = makeAzElRange({
  az: { min: -76, max: 76, stepSize: 2 },
  el: { min: -35, max: 35, stepSize: 5 }
});

export const AzElRangeGA2 = makeAzElRange({
  az: { min: -45, max: 45, stepSize: 3 },
  el: { min: -45, max: 45, stepSize: 3 }
});

function makeAzElRange({ az, el }) {
  const azRange = az.max - az.min;
  const elRange = el.max - el.min;
  const ratio = azRange / elRange;
  az.num = Math.floor(azRange / az.stepSize) + 1;
  el.num = Math.floor(elRange / el.stepSize) + 1;

  return { az, el, ratio };
}

export const BeamRankTypes = {
  1: 'primary',
  2: 'secondary',
  3: 'tertiary',
  4: 'manual'
};

export const azElErrorMessage = {
  az: (config) => `Azimuth must be 361 or between ${config.az.min} and ${config.az.max}`,
  el: (config) => `Elevation must be 361 or between ${config.el.min} and ${config.el.max}`
};

export const defaultSWDeviceTypesV2 = {
  es3_28: {
    title: 'ES3_28',
    name: 'es3_28',
    description: 'Echo Outdoor - 28 GHz'
  },
  es4_39: {
    title: 'ES4_39',
    name: 'es4_39',
    description: 'Echo Outdoor - 39 GHz'
  },
  pivot5g: {
    title: 'Pivot 5G',
    name: 'pivot5g',
    description: 'Pivot 5G'
  },
  hbf_donor: {
    title: 'Pivot 5G Donor',
    name: 'donor',
    description: 'Pivot Donor - HBF'
  },
  horn_wide_service: {
    title: 'Pivot 5G Service',
    name: 'service',
    description: 'Pivot Service - Wide Horn'
  },
  hbf_service: {
    title: 'Pivot 5G Service',
    name: 'service',
    description: 'Pivot Service - HBF'
  },
  horn_narrow_service: {
    title: 'Pivot 5G Service',
    name: 'service',
    description: 'Pivot Service - Narrow Horn'
  }
};

export const daysSelection = {
  sunday: false,
  monday: true,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false
};

export const dayPrefixes = {
  sunday: 'Sun',
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat'
};

export const ordinalSelection = {
  first: true,
  second: false,
  third: false,
  fourth: false
};

export const schedTypes = {
  day: 'daily',
  week: 'weekly',
  month: 'monthly'
};

export const defaultPeriodicSwCheckConfig = {
  daily: { selected: true, name: 'daily', scheduleType: 'day', recurrence: 1 },
  weekly: {
    selected: false,
    name: 'weekly',
    scheduleType: 'week',
    recurrence: 1,
    days: daysSelection
  },
  monthly: {
    selected: false,
    name: 'monthly',
    scheduleType: 'month',
    recurrence: 1,
    occurrence: {
      onDay: { selected: true, day: 1 },
      onSequence: { selected: false, ordinal: ordinalSelection, days: daysSelection }
    }
  }
};

export const PERMISSION_ERROR_MESSAGE =
  'You don’t have a permission to perform this task. Please contact your admin for further assistance.';

export const DEVICE_NOT_ONLINE_ERROR_MESSAGE = 'Device must be online';

export const commissionCustomStatusValues = {
  raster: 'Rastering',
  awaiting_activeBeam: 'Awaiting Active Beam',
  oscillation_mitigation: 'Oscillation Mitigation',
  optimizing: 'Optimizing',
  error: 'Error',
  completed: 'Completed'
};

export const DEVICES_PAGE_TAB = {
  pivot: 0,
  echo: 1,
  all: 2
};

export const HEATMAP_RETRIEVE_SCREEN_INDEXES = {
  SETTIMEOUT: 0,
  IN_PROGRESS: 1,
  SUCCESS: 2,
  DUPLICATE: 3,
  ERROR: 4
};

export const presetPolygonColors = [
  '#FE2712',
  '#C21460',
  '#8601AF',
  '#4424D6',
  '#0247FE',
  '#347C98',
  '#66B032',
  '#B2D732',
  '#FEFE33',
  '#FCCC1A',
  '#FB9902',
  '#FC600A'
];

export const USER_PREFERENCE_SETS = {
  FILTER_SET: 'filter-set',
  COLUMNS_SET: 'columns-set',
  CHART_SET: 'chart-set',
  CHART: 'chart',
  ANNOTATION: 'annotation'
};

export const DEFAULT_PIVOT_TAB_COLUMNS = [
  {
    id: 'pod_name_col',
    uiName: 'Pod Name',
    disabled: false,
    selected: true
  },
  {
    id: 'pod_code_col',
    uiName: 'Pod Code',
    disabled: false,
    selected: true
  },
  {
    id: 'gen_col',
    uiName: 'Gen',
    disabled: false,
    selected: true
  },
  {
    id: 'parent_name_col',
    uiName: 'Parent Name',
    disabled: true,
    selected: false
  },
  {
    id: 'parent_pci_col',
    uiName: 'Parent PCI',
    disabled: true,
    selected: false
  },
  {
    id: 'pod_code_of_children_col',
    uiName: 'Pod Code of Children',
    disabled: true,
    selected: false
  },
  {
    id: 'number_of_2_hop_children_col',
    uiName: 'Number of 2-Hop Children',
    disabled: true,
    selected: false
  },
  {
    id: 'location_col',
    uiName: 'Location (Lat, Long)',
    disabled: false,
    selected: true
  },
  {
    id: 'alarms_col',
    uiName: 'Alarms',
    disabled: false,
    selected: true
  },
  {
    id: 'connection_status_col',
    uiName: 'Connection Status',
    disabled: false,
    selected: true
  },
  {
    id: 'sw_version_col',
    uiName: 'SW Version',
    disabled: false,
    selected: true
  },
  {
    id: 'device_id_col',
    uiName: 'Device ID',
    disabled: false,
    selected: true
  },
  {
    id: 'receive_average_power_h_col',
    uiName: 'Receive Average Power-H',
    disabled: true,
    selected: false
  },
  {
    id: 'receive_average_power_v_col',
    uiName: 'Receive Average Power-V',
    disabled: true,
    selected: false
  },
  {
    id: 'transmit_average_power_h_col',
    uiName: 'Transmit Average Power-H',
    disabled: true,
    selected: false
  },
  {
    id: 'transmit_average_power_v_col',
    uiName: 'Transmit Average Power-V',
    disabled: true,
    selected: false
  },
  {
    id: 'dl_gain_v_col',
    uiName: 'DL Gain-V',
    disabled: false,
    selected: false
  },
  {
    id: 'dl_gain_h_col',
    uiName: 'DL Gain-H',
    disabled: false,
    selected: false
  },
  {
    id: 'ul_gain_v_col',
    uiName: 'UL Gain-V',
    disabled: false,
    selected: false
  },
  {
    id: 'ul_gain_h_col',
    uiName: 'UL Gain-H',
    disabled: false,
    selected: false
  },
  {
    id: 'locked_unlocked_col',
    uiName: 'Locked/Unlocked',
    disabled: false,
    selected: false
  },
  {
    id: 'wifi_enabled_col',
    uiName: 'Wi-Fi Enabled',
    disabled: false,
    selected: false
  },
  {
    id: 'device_temperature_col',
    uiName: 'Device Temperature',
    disabled: true,
    selected: false
  },
  {
    id: 'azimuth_absolute_col',
    uiName: 'Azimuth - Absolute',
    disabled: true,
    selected: false
  },
  {
    id: 'azimuth_electrical_col',
    uiName: 'Azimuth - Electrical',
    disabled: false,
    selected: false
  },
  {
    id: 'azimuth_mechanical_col',
    uiName: 'Azimuth - Mechanical',
    disabled: true,
    selected: false
  },
  {
    id: 'downtilt_absolute_col',
    uiName: 'Downtilt - Absolute',
    disabled: true,
    selected: false
  },
  {
    id: 'downtilt_electrical_col',
    uiName: 'Downtilt - Electrical',
    disabled: false,
    selected: false
  },
  {
    id: 'downtilt_mechanical_col',
    uiName: 'Downtilt - Mechanical',
    disabled: true,
    selected: false
  },
  {
    id: 'protected_col',
    uiName: 'Protected',
    disabled: true,
    selected: false
  },
  {
    id: 'factory_col',
    uiName: 'Factory',
    disabled: true,
    selected: false
  }
];

export const DEFAULT_ECHO_TAB_COLUMNS = [
  {
    id: 'echo_id_col',
    uiName: 'Echo ID',
    disabled: false,
    selected: true
  },
  {
    id: 'echo_name_col',
    uiName: 'Echo Name',
    disabled: false,
    selected: true
  },
  {
    id: 'model_col',
    uiName: 'Model',
    disabled: false,
    selected: true
  },
  {
    id: 'parent_name_col',
    uiName: 'Parent Name',
    disabled: true,
    selected: false
  },
  {
    id: 'parent_pci_col',
    uiName: 'Parent PCI',
    disabled: true,
    selected: false
  },
  {
    id: 'location_col',
    uiName: 'Location (Lat, Long)',
    disabled: false,
    selected: true
  },
  {
    id: 'alarms_col',
    uiName: 'Alarms',
    disabled: false,
    selected: true
  },
  {
    id: 'connection_status_col',
    uiName: 'Connection Status',
    disabled: false,
    selected: true
  },
  {
    id: 'sw_version_col',
    uiName: 'SW Version',
    disabled: false,
    selected: true
  },
  {
    id: 'device_id_col',
    uiName: 'Device ID',
    disabled: false,
    selected: true
  },
  {
    id: 'receive_average_power_h_col',
    uiName: 'Receive Average Power-H',
    disabled: true,
    selected: false
  },
  {
    id: 'receive_average_power_v_col',
    uiName: 'Receive Average Power-V',
    disabled: true,
    selected: false
  },
  {
    id: 'transmit_average_power_h_col',
    uiName: 'Transmit Average Power-H',
    disabled: true,
    selected: false
  },
  {
    id: 'transmit_average_power_v_col',
    uiName: 'Transmit Average Power-V',
    disabled: true,
    selected: false
  },
  {
    id: 'dl_gain_v_col',
    uiName: 'DL Gain-V',
    disabled: false,
    selected: false
  },
  {
    id: 'dl_gain_h_col',
    uiName: 'DL Gain-H',
    disabled: false,
    selected: false
  },
  {
    id: 'ul_gain_v_col',
    uiName: 'UL Gain-V',
    disabled: false,
    selected: false
  },
  {
    id: 'ul_gain_h_col',
    uiName: 'UL Gain-H',
    disabled: false,
    selected: false
  },
  {
    id: 'locked_unlocked_col',
    uiName: 'Locked/Unlocked',
    disabled: false,
    selected: false
  },
  {
    id: 'wifi_enabled_col',
    uiName: 'Wi-Fi Enabled',
    disabled: false,
    selected: false
  },
  {
    id: 'device_temperature_col',
    uiName: 'Device Temperature',
    disabled: true,
    selected: false
  },
  {
    id: 'azimuth_absolute_col',
    uiName: 'Azimuth - Absolute',
    disabled: true,
    selected: false
  },
  {
    id: 'azimuth_electrical_col',
    uiName: 'Azimuth - Electrical',
    disabled: false,
    selected: false
  },
  {
    id: 'azimuth_mechanical_col',
    uiName: 'Azimuth - Mechanical',
    disabled: true,
    selected: false
  },
  {
    id: 'downtilt_absolute_col',
    uiName: 'Downtilt - Absolute',
    disabled: true,
    selected: false
  },
  {
    id: 'downtilt_electrical_col',
    uiName: 'Downtilt - Electrical',
    disabled: false,
    selected: false
  },
  {
    id: 'downtilt_mechanical_col',
    uiName: 'Downtilt - Mechanical',
    disabled: true,
    selected: false
  },
  {
    id: 'protected_col',
    uiName: 'Protected',
    disabled: true,
    selected: false
  },
  {
    id: 'factory_col',
    uiName: 'Factory',
    disabled: true,
    selected: false
  }
];

export const DEFAULT_ALL_DEVICES_TAB_COLUMNS = [
  {
    id: 'device_id_col',
    uiName: 'Devices',
    disabled: false,
    selected: true
  },
  {
    id: 'device_type_col',
    uiName: 'Device Type',
    disabled: false,
    selected: true
  },
  {
    id: 'gen_model_col',
    uiName: 'Gen/Model',
    disabled: false,
    selected: false
  },
  {
    id: 'location_col',
    uiName: 'Location (Lat, Long)',
    disabled: false,
    selected: true
  },
  {
    id: 'sw_version_col',
    uiName: 'SW Version',
    disabled: false,
    selected: true
  },
  {
    id: 'alarms_col',
    uiName: 'Alarms',
    disabled: false,
    selected: true
  },
  {
    id: 'connection_status_col',
    uiName: 'Connection Status',
    disabled: false,
    selected: true
  },
  {
    id: 'protected_col',
    uiName: 'Protected',
    disabled: true,
    selected: false
  },
  {
    id: 'factory_col',
    uiName: 'Factory',
    disabled: true,
    selected: false
  }
];

export const emailRegex =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

export const phoneNumberRegex =
  /^\+?\d{1,4}?[-.\u2013\u2014\s]?\(?\d{1,3}?\)?[-.\u2013\u2014\s]?\d{1,4}[-.\u2013\u2014\s]?\d{1,4}[-.\s]?\d{1,9}$/;

export const stringAllowedCharactersRegex = /^[a-zA-Z0-9-_.\s]*$/;

export const deletePolygonConfirmation = {
  title: 'Do you want to delete a polygon?',
  confirmText: 'Yes',
  cancelText: 'No'
};

export const deletePolygonIncludedInRuleConfirmation = {
  title: 'The polygon is used in alerts. Do you want to remove the polygon from alert rules and to delete it?',
  confirmText: 'Yes',
  cancelText: 'No'
};

export const twoHopCustomStatusValues = {
  running: 'Running',
  error: 'Error',
  completed: 'Completed'
};

export const DEFAULT_PIVOT_IDS_OBJ = {
  hop1donor1: null,
  hop1service1: null,
  hop1service2: null,
  hop2donor1: null,
  hop2service1: null,
  hop2service2: null
};

export const POLYGON_OPTIONS_MODAL_MODE = {
  CREATION: 0,
  UPDATION: 1,
  DUPLICATION: 3
};

export const SWUpdateStatuses = {
  COMPLETED: 'completed',
  SCHEDULED: 'scheduled',
  DOWNLOADING: 'downloading',
  REBOOTING: 'rebooting',
  ERROR: 'error',
  QUEUEING: 'queueing',
  WARNING: 'warning',
  SCHEDULED_ACTIVATION: 'scheduled_activation'
};

export const ERROR_CODES = {
  400: 'The parameters passed in the request body are invalid. Please try again later.',
  401: 'Missing authorization token or no permissions. Please try again later.',
  403: 'Device is offline so action cannot be performed.Please try again later.',
  404: 'Resource Not Found. Please try again later.',
  405: 'The target device does not support the specified operation. Please try again later.',
  417: 'Device responded with error: error received from device 417. Please try again later.',
  500: 'Internal error while processing the search request. Please try again later.'
};

export const BEAM_ERROR_CODES = {
  SECTOR_OP_ENABLED: 'sector_op_enabled',
  INVALID_POLARITY: 'invalid_polarity',
  INVALID_PCI: 'invalid_pci',
  INVALID_SSB_ARFCN: 'invalid_ssb_arfcn',
  INVALID_SCS: 'invalid_scs'
};

export const BEAM_ERROR_MESSAGES = {
  [BEAM_ERROR_CODES.SECTOR_OP_ENABLED]: 'Sector is operation enabled',
  [BEAM_ERROR_CODES.INVALID_POLARITY]: 'Invalid polarity value',
  [BEAM_ERROR_CODES.INVALID_PCI]: 'Invalid PCI value',
  [BEAM_ERROR_CODES.INVALID_SSB_ARFCN]: 'Invalid SSB ARFCN value',
  [BEAM_ERROR_CODES.INVALID_SCS]: 'Invalid SCS value',
  DEFAULT: 'An error occurred while setting custom beam'
};
